<template>
  <div class="item">
    <div class="item-name">
      <p>{{ this.itemName }}</p>
    </div>
    <div class="item-price">
      <p>S${{ this.itemValue }}</p>
    </div>
    <!--
    <div class="item-quantity">
      <p>3</p>
    </div>
    -->
    <div class="item-alter">
      <button @click.prevent="decreaseQuantity" class="decrease-quantity">
        -
      </button>
      <button class="quantity">{{ this.itemQuantity }}</button>
      <button @click.prevent="increaseQuantity" class="increase-quantity">
        +
      </button>
    </div>
  </div>
</template>

<script>
//import db from "../firebase/firebaseInit";

export default {
  name: "CartItemView",
  props: ["itemIndex", "itemName", "itemValue", "itemQuantity", "mainCart"],
  methods: {
    updateCart() {
      for (let i = 1; i < this.mainCart.length; i = i + 3) {
        if (this.mainCart[i] === this.itemName) {
          if (this.itemQuantity === 0) {
            this.mainCart.splice(i, 3);
            if (this.mainCart.length === 1) {
              //this.mainCart = [];
              this.mainCart.splice(0, this.mainCart.length);
            }
          } else {
            this.mainCart[i + 2] = this.itemQuantity;
          }
        }
      }

      this.$emit("update-cart", this.mainCart);
      this.$store.state.profileCart = this.mainCart;
      this.$store.dispatch("updateCart");
      //EMIT TO PUSH TO CART AND TO SERVER and update total items and cost
      /*
      const dataBase = await db
        .collection("users")
        .doc(this.$store.state.profileId);
      await dataBase.update({
        cart: this.mainCart,
      });
      */
    },
    increaseQuantity() {
      this.itemQuantity++;
      if (this.itemQuantity > 10) {
        this.itemQuantity = 10;
        this.$toast.warning(`Maximum Quantity Reached for ${this.itemName}`, {
          timeout: 1500,
          position: "bottom-center",
        });
        return;
      }
      this.updateCart();
    },
    decreaseQuantity() {
      this.itemQuantity--;
      this.updateCart();
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  margin: 8px 8px;
  background-color: #fff;
  border-bottom: 5px solid rgb(216, 216, 216);
  display: flex;
  flex-direction: row;
  height: 100px;
  border-radius: 30px;

  p {
    font-size: 20px;

    @media (max-width: 800px) {
      font-size: initial;
    }
  }

  @media (max-width: 800px) {
    height: 80px;
    border-radius: 20px;
  }

  .item-name {
    padding: 30px 0;

    //padding-top: 30px;
    flex-basis: 40%;
    display: flex;
    justify-content: center;
    align-items: center;

    /*
    @media (max-width: 380px) {
      padding-left: 18px;
      padding-top: 18px;
    }
    */

    @media (max-width: 800px) {
      margin-left: 10px;
      padding-top: 27px;
      flex-basis: 30%;
    }
  }

  .item-price {
    padding: 30px 0;
    //padding-top: 30px;
    display: flex;
    justify-content: center;
    flex-basis: 20%;
    align-items: center;

    @media (max-width: 800px) {
      padding-top: 27px;
      flex-basis: 20%;
    }
  }

  .item-alter {
    display: flex;
    justify-content: center;
    flex-basis: 40%;
    gap: 16px;
    padding-top: 8px;

    @media (max-width: 800px) {
      gap: 12px;
      flex-basis: 50%;
      padding-top: 0px;
    }

    .decrease-quantity {
      text-align: center;
      cursor: pointer;
      width: 50px;
      height: 50px;
      border-radius: 50px;
      background-color: rgb(255, 0, 60);
      border: 2px red solid;
      font-weight: 500;

      @media (max-width: 800px) {
        margin-top: 19px;
        width: 40px;
        height: 40px;
      }
    }

    .quantity {
      text-align: center;
      height: 50px;
      width: 50px;
      border-radius: 50px;
      // or greeen
      color: #fff;
      font-weight: 500;
      border: 2px #000 solid;

      @media (max-width: 800px) {
        margin-top: 19px;
        width: 40px;
        height: 40px;
      }
    }

    .increase-quantity {
      text-align: center;
      cursor: pointer;
      width: 50px;
      height: 50px;
      border-radius: 50px;
      background-color: rgb(80, 255, 80);
      border: 2px rgb(80, 255, 80) solid;
      font-weight: 500;

      @media (max-width: 800px) {
        margin-top: 19px;
        width: 40px;
        height: 40px;
      }
    }
  }

  /*
  .item-quantity {
    padding-top: 30px;
    display: flex;
    justify-content: center;
    flex-basis: 20%;

    @media (max-width: 800px) {
      flex-basis: 15%;
    }
  }
  */
}
</style>
